// API configuration from environment variables
const API_BASE_URL = import.meta.env.VITE_EMAIL_API_BASE_URL;
const API_ENDPOINT = import.meta.env.VITE_EMAIL_API_ENDPOINT;

// Construct full API URL
export const EMAIL_API_URL = API_BASE_URL && API_ENDPOINT 
  ? `${API_BASE_URL}${API_ENDPOINT}` 
  : (() => {
      console.error('Missing API configuration in .env file');
      return null;
    })();

export const SSO_URL = import.meta.env.VITE_SSO_URL || 'https://sso.itcpr.org';
